import { render, staticRenderFns } from "./SectionDialog.vue?vue&type=template&id=753214da&scoped=true"
import script from "./SectionDialog.vue?vue&type=script&lang=ts"
export * from "./SectionDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SectionDialog.vue?vue&type=style&index=0&id=753214da&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "753214da",
  "1d724cd7"
  
)

export default component.exports